<template>
    <v-card class="pa-3" v-if="permission || superUser" :value="$route.path">
        <v-row class="d-flex justify-center">
            <v-col cols="12" md="12" sm="12">
                <v-card elevation="0">
                    <v-card-title
                        v-if="emails && !emails.length"
                        class="d-flex text-h6 font-weight-bold justify-center pr-0 pl-0"
                    >
                    <span class="text-center pa-1">{{
                        translations.noPaymentMethodNeededTitle[lang]
                    }}</span>
                    </v-card-title>
                    <v-row
                class="d-flex justify-start"
            >
                <v-col cols="12" xl="6" lg="8" md="10" sm="12">
                  
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left" style="height: 10px;">Email</th>
                        <th class="text-left" style="height: 10px;">{{ translations.actions[lang] }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr></tr>
                    <tr v-for="(emailData) in emails" :key="emailData.store_subscription_email_notification_id">
                        <td v-if="emailData.store_subscription_email_notification_id">{{ emailData.email }}</td>
                        <td v-else class="pl-0 d-flex"> 
                           <v-text-field   
                            class="pl-0 pt-0 mt-0 d-flex align-end"              
                            color="secondary"
                            no-messages
                            hide-details
                            v-model="emailData.email">
                        </v-text-field> 
                    </td>
                        <td>
                            <v-tooltip v-if="emailData.store_subscription_email_notification_id" color="secondary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="secondary"
                                            icon
                                            v-on="on"
                                            @click="openDeleteDialog(emailData)"
                                        >
                                            <v-icon
                                                v-text="icons.mdiDelete"
                                            ></v-icon>
                                        </v-btn>
                                    </template>

                                    <span
                                        class="font-weight-bold"
                                        v-text="translations.delete[lang]"
                                    ></span>
                                </v-tooltip>
                                <v-tooltip v-else color="secondary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="secondary"
                                            icon
                                            :disabled="!validateEmail(emailData.email)"
                                            v-on="on"
                                            :loading="loading"
                                            @click="addEmail(emailData.email)"
                                        >
                                            <v-icon
                                                v-text="icons.mdiContentSave"
                                            ></v-icon>
                                        </v-btn>
                                    </template>

                                    <span
                                        class="font-weight-bold"
                                        v-text="translations.save[lang]"
                                    ></span>
                                </v-tooltip>
                        </td>
                    </tr>
                    <tr v-if="!canAdd">
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-if="canAdd" style="background: #eaedf1">
                        <td class="d-flex justify-center align-center"> <v-tooltip color="secondary" top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="secondary"
                                            icon
                                            size="60"
                                            v-on="on"
                                            @click="addNewEmail()"
                                        >
                                            <v-icon
                                                v-text="icons.mdiPlusBox"
                                            ></v-icon>
                                        </v-btn>
                                    </template>

                                    <span
                                        class="font-weight-bold"
                                        v-text="translations.addNewEmail[lang]"
                                    ></span>
                                </v-tooltip></td>
                        <td></td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
                </v-col>
             
            </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
                v-model="deleteDialog"
                :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
            >
            <b-card
                type="delete"
                :title="translations.deleteEmail[lang]"
                :submit-text="translations.delete"
                :loading="loading"
                @cancel="deleteDialog = false"
                @submit="startDeleteEmail(deletingEmailData)"
            >
                <div class="subtitle-1 font-weight-medium pt-2 px-2">
                    {{ translations.deleteConfirmationMessage[lang] }}
                    <span class="font-weight-bold text--primary">{{
                        deletingEmailData.email
                    }}</span
                    >{{ translations.questionmark[lang] }}
                </div>
            </b-card>
            </v-dialog>
    </v-card>
</template>

<script>
import translations from "@/utils/translations/general/settings/billingDashboard";
import { mapState, mapMutations, mapActions } from "vuex";

import {
    mdiDelete,
    mdiPlusBox,
    mdiContentSave
} from "@mdi/js";


export default {
    name: "BillingDashboardEmailNotifications",

    mixins: [translations],
    data() {
        return {
            tab: this.$route.path,
            icons: {
                mdiDelete,
                mdiPlusBox,
                mdiContentSave
            },
            deletingEmailData:{},
            deleteDialog: false
        }
    },
    computed: {
        ...mapState(["superUser", "loading"]),

        ...mapState(
            "general/settings/billingDashboard/emailNotifications",
            ["emails", "maxEmails"]
        ),

        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return (
                this.superUser ||
                (this.$store.state.permissions.general_settings
                    ? this.$store.state.permissions.general_settings.billing_dashboard.read
                    : null)
            );
        },
        canAdd(){
            return this.emails.length < this.maxEmails && !this.emails.find(x => !x.store_subscription_email_notification_id)
        }
    },
    methods: {

    ...mapActions("general/settings/billingDashboard/emailNotifications", [
            "getEmails",
            "addEmail",
            "deleteEmail",
        ]),
        openDeleteDialog(emailData){
            this.deletingEmailData = emailData
            this.deleteDialog = true
        },
        startDeleteEmail(emailData){
            this.deleteEmail(emailData.store_subscription_email_notification_id)
            this.deleteDialog = false
        },

        addNewEmail(){
            this.emails.push({
                email:"",
                store_subscription_email_notification_id: null
            })
        },
        validateEmail(email) {
            var re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        // saveEmail(emailData){
        //     this.addEmail(emailData.email)
        // },
    },
    watch: {
        permission: {
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/forbidden`
                    );
                }
            }
        }
    },
    // mounted() {
    //     if (!this.emails?.length || !this.maxEmails) {
    //         this.getEmails()
    //     }
    // },
};
</script>
